import { render, staticRenderFns } from "./clientLis-crm-sales-contact.vue?vue&type=template&id=57c196c8"
import script from "./clientLis-crm-sales-contact.vue?vue&type=script&lang=js"
export * from "./clientLis-crm-sales-contact.vue?vue&type=script&lang=js"
import style0 from "./clientLis-crm-sales-contact.vue?vue&type=style&index=0&id=57c196c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports